export const QUESTIONS = [
  {
    id: "Q1",
    text: "當你接手一項新工作時，你最理想的狀態是？",
    options: [
      { key: "A", text: "有清楚流程與既定標準可遵循" },
      { key: "B", text: "有大致方向，其餘可自行調整" },
      { key: "C", text: "目標明確，但做法高度自由" },
      { key: "D", text: "邊做邊定義規則也沒問題" },
    ],
  },
  // {
  //   id: "Q2",
  //   text: "面對一份分析任務，你最在意的是？",
  //   options: [
  //     { key: "A", text: "數據是否正確、邏輯是否一致" },
  //     { key: "B", text: "是否符合制度或既定規範" },
  //     { key: "C", text: "是否能幫助決策更清楚" },
  //     { key: "D", text: "是否能直接轉化為行動" },
  //   ],
  // },
  // {
  //   id: "Q3",
  //   text: "在團隊中，你最自在的角色是？",
  //   options: [
  //     { key: "A", text: "獨立分析與整理資料" },
  //     { key: "B", text: "提供專業意見給需要的人" },
  //     { key: "C", text: "協調不同角色、整合資訊" },
  //     { key: "D", text: "對外說明想法、主導討論" },
  //   ],
  // },
  // {
  //   id: "Q4",
  //   text: "當工作方向突然調整時，你通常會？",
  //   options: [
  //     { key: "A", text: "感到不安，希望儘快穩定下來" },
  //     { key: "B", text: "需要時間重新適應" },
  //     { key: "C", text: "視為工作的一部分" },
  //     { key: "D", text: "覺得有挑戰性，反而投入" },
  //   ],
  // },
  // {
  //   id: "Q5",
  //   text: "你比較能長期適應哪一種工作環境？",
  //   options: [
  //     { key: "A", text: "規則清楚、變動少" },
  //     { key: "B", text: "架構清楚，但偶有變化" },
  //     { key: "C", text: "專案型、內容多變" },
  //     { key: "D", text: "高彈性、高不確定" },
  //   ],
  // },
  // {
  //   id: "Q6",
  //   text: "當你發現資料中有不合理之處時，你通常會？",
  //   options: [
  //     { key: "A", text: "確認是否影響整體結果即可" },
  //     { key: "B", text: "記錄下來，視需求再處理" },
  //     { key: "C", text: "回頭檢查邏輯與來源" },
  //     { key: "D", text: "持續追查直到釐清原因" },
  //   ],
  // },
  // {
  //   id: "Q7",
  //   text: "你如何看待工作中的溝通？",
  //   options: [
  //     { key: "A", text: "能減少就減少，專注把事做好" },
  //     { key: "B", text: "必要時精準溝通即可" },
  //     { key: "C", text: "視為合作與效率的一部分" },
  //     { key: "D", text: "本身就是工作重心" },
  //   ],
  // },
  // {
  //   id: "Q8",
  //   text: "你對理想職涯的想像比較接近哪一個？",
  //   options: [
  //     { key: "A", text: "穩定、可預期、長期累積" },
  //     { key: "B", text: "成為某一領域的關鍵專家" },
  //     { key: "C", text: "在組織中具影響力" },
  //     { key: "D", text: "能參與重要決策或改變" },
  //   ],
  // },
  // {
  //   id: "Q9",
  //   text: "你比較常從哪個角度思考問題？",
  //   options: [
  //     { key: "A", text: "這樣做合不合理、對不對" },
  //     { key: "B", text: "是否符合規範與標準" },
  //     { key: "C", text: "是否對決策有幫助" },
  //     { key: "D", text: "是否能產生實際結果" },
  //   ],
  // },
  // {
  //   id: "Q10",
  //   text: "如果有機會進入跨文化或跨制度的環境，你會？",
  //   options: [
  //     { key: "A", text: "偏好留在熟悉的體系" },
  //     { key: "B", text: "若條件成熟可以考慮" },
  //     { key: "C", text: "覺得是很好的成長機會" },
  //     { key: "D", text: "本身就希望有這樣的發展" },
  //   ],
  // },
  // {
  //   id: "Q11",
  //   text: "你如何看待專業判斷這件事？",
  //   options: [
  //     { key: "A", text: "只要符合規定即可" },
  //     { key: "B", text: "在規定內給出最穩妥答案" },
  //     { key: "C", text: "結合情境與數據做判斷" },
  //     { key: "D", text: "願意承擔責任，做出結論" },
  //   ],
  // },
  // {
  //   id: "Q12",
  //   text: "以下哪一句最接近你目前的狀態？",
  //   options: [
  //     { key: "A", text: "我希望在穩定體系中累積專業" },
  //     { key: "B", text: "我希望成為某一專業領域的關鍵角色" },
  //     { key: "C", text: "我希望參與決策、影響方向" },
  //     { key: "D", text: "我希望職涯具有高度彈性" },
  //   ],
  // },
];
